const revealLogosSeenAfterShowAll = (containerEl) => {
	const hiddenLogoEls = containerEl.querySelectorAll(
		'.logogrid-item.scrolltrigger_unseen'
	);
	for (let kk = 0; kk < hiddenLogoEls.length; kk += 1) {
		if (
			hiddenLogoEls[kk].getBoundingClientRect().top <=
			(window.innerHeight || document.documentElement.clientHeight)
		) {
			hiddenLogoEls[kk].classList.remove('scrolltrigger_unseen');
		}
	}
};

const containerEls = document.querySelectorAll('[data-js=logogrid]');
for (let j = containerEls.length - 1; j >= 0; j -= 1) {
	const gridEl = containerEls[j].querySelector('[data-js=logogrid-list]');
	const elToggleButton = containerEls[j].querySelector(
		`[data-js=logogrid-toggle]`
	);
	elToggleButton.addEventListener('click', () => {
		const isExpanded = elToggleButton.getAttribute('aria-expanded') !== 'false';
		if (isExpanded) {
			gridEl.style.removeProperty('max-height');
			gridEl.style.minHeight = `${gridEl.offsetHeight}px`;
			containerEls[j].classList.remove('logogrid--all');
			setTimeout(() => {
				gridEl.style.minHeight = 0;
				elToggleButton.setAttribute('aria-expanded', 'false');
			}, 10);
		} else {
			gridEl.style.removeProperty('min-height');
			gridEl.style.maxHeight = `${gridEl.offsetHeight}px`;
			containerEls[j].classList.add('logogrid--all');
			setTimeout(() => {
				// expand the height
				gridEl.style.maxHeight = `${gridEl.scrollHeight}px`;
				elToggleButton.setAttribute('aria-expanded', 'true');
				revealLogosSeenAfterShowAll(gridEl);
			}, 10);
		}
	});
}
